import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "50vh",
        "@media (min-width: 1300px)": {
            height: "55vh",
        },
    },
    TopFiveFailureCodesTitle: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(3),
        fontSize: "24px !important",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        width: "100%",
        textAlign: "start",
    },
    graphContainer: {
        display: "flex",
        height: "100%",
        justifyContent: "flex-start",
        position: "relative",
        padding: `${theme.spacing(5)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        overflowX: "auto",
        overflowY: "hidden",
    },
    graphGridItemContainer: {
        height: "40vh !important",
        minWidth: 1000,
        "@media (min-width: 1600px)": {
            height: "42vh !important",
        },
        marginBottom: theme.spacing(1),
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.graphs.main,
        },
    },
    graphTitle: {
        margin: `${theme.spacing(2)} 0 !important`,
        textAlign: "center",
    },
}));
